export class AppAuthUser {
    identityId = '';
    email = '';
    firstName = '';
    lastName = '';
    isAuthenticated = false;
    bearerToken = '';
    isSSOUser = false;
}
